import { useScenarioForm } from './contexts';
import styles from './global-configs.module.scss';
import {
  DropdownField,
  NumberField,
  TanstackFieldWrapper,
} from 'components/form-fields-2';
import { capitalize, lowerCase } from 'lodash-es';
export const GlobalConfigs = () => {
  const { form } = useScenarioForm();
  return (
    <div className={styles.configFormContainer}>
      <h2 className={styles.configFormTitle}>Global Configs</h2>
      <div className={styles.inputsContainer}>
        <form.Field name="globalConfig.timeFormat">
          {(field) => (
            <TanstackFieldWrapper<string> field={field}>
              {(props) => (
                <DropdownField
                  label="Time Format"
                  id="timeFormat"
                  titleText="Time Format"
                  items={['monthly', 'daily']}
                  itemToString={(item: string | null) => capitalize(item || '')}
                  {...props}
                />
              )}
            </TanstackFieldWrapper>
          )}
        </form.Field>

        <form.Field name="globalConfig.qiFormat">
          {(field) => (
            <TanstackFieldWrapper<string> field={field}>
              {(props) => (
                <DropdownField
                  id="qiFormat"
                  label="qi Format"
                  titleText="qi Format"
                  items={['monthly', 'daily']}
                  itemToString={(item: string | null) => capitalize(item || '')}
                  {...props}
                />
              )}
            </TanstackFieldWrapper>
          )}
        </form.Field>

        <form.Field name="globalConfig.diFormat">
          {(field) => (
            <TanstackFieldWrapper<string> field={field}>
              {(props) => (
                <DropdownField
                  id="diFormat"
                  label="Di Format"
                  titleText="Di Format"
                  items={['effective', 'nominal']}
                  itemToString={(item: string | null) => capitalize(item || '')}
                  {...props}
                />
              )}
            </TanstackFieldWrapper>
          )}
        </form.Field>

        <form.Field name="globalConfig.durationOption">
          {(field) => (
            <TanstackFieldWrapper<string> field={field}>
              {(props) => (
                <DropdownField
                  id="durationOption"
                  label="Duration Option"
                  titleText="Duration Option"
                  items={[
                    'production_start',
                    'production_end',
                    'forecast_start',
                  ]}
                  itemToString={(item: string | null) =>
                    `From ${lowerCase(item || '')}`
                  }
                  {...props}
                />
              )}
            </TanstackFieldWrapper>
          )}
        </form.Field>

        {/* dummy div */}
        <div />

        <form.Field name="globalConfig.durationFormat">
          {(field) => (
            <TanstackFieldWrapper<string> field={field}>
              {(props) => (
                <DropdownField
                  id="durationFormat"
                  label="Duration Format"
                  titleText="Duration Format"
                  items={['yearly', 'monthly']}
                  itemToString={(item: string | null) => capitalize(item || '')}
                  {...props}
                />
              )}
            </TanstackFieldWrapper>
          )}
        </form.Field>

        <form.Field name="globalConfig.durationPeriod">
          {(field) => (
            <TanstackFieldWrapper<number | null> field={field}>
              {(props) => (
                <NumberField
                  id="durationPeriod"
                  label="Duration Period"
                  {...props}
                />
              )}
            </TanstackFieldWrapper>
          )}
        </form.Field>
      </div>
    </div>
  );
};
